export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'DASHBOARDS': 'Dashboards',
            'DASHBOARD': {
                'TITLE': 'Dashboard',
                'BADGE': '25'
            },
            'APPLICATIONS': 'Applications',
            'SAMPLE': {
                'TITLE': 'Sample',
                'BADGE': '25'
            },
            'USER_MANAGEMENT': 'User Management',
            'ADMIN': { 'TITLE': 'Admin' },
            'MANAGE_USERS': { 'TITLE': 'Search and Manage Users' },
            'ADD_NEW_USER': { 'TITLE': 'Add a New User' }
        }
    }
};
